export const Backbutton = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="65" height="65" fill="none" viewBox="0 0 65 65"
             onClick={props.onClick}>
            <circle cx="32.5" cy="32.5" r="32.5" fill="#585B6A"/>
            <path fill="#fff"
                  d="m18.429 32.893-1.869-1.661-1.476 1.66 1.476 1.662 1.869-1.661Zm26.928 2.5a2.5 2.5 0 0 0 0-5v5ZM28.528 17.768 16.56 31.232l3.737 3.322 11.969-13.465-3.738-3.321ZM16.56 34.554l11.968 13.464 3.738-3.322-11.969-13.464-3.737 3.322Zm1.869.839h26.928v-5H18.43v5Z"/>
        </svg>
    )
}